import React, { useState } from 'react'
import Navbar from '../global/Navbar'
import Mission from '../components/About/Mission';
import OurCeo from '../components/About/OurCeo';

const About = () => {
   const [active,setActive] = useState("vission_mission");
  
     const render = () => {
      switch (active) {
        case "vission_mission":
          return <Mission/>;
        case "about_ceo":
          return <OurCeo/>;
        default:
          return <h1>Default View</h1>;
      }
    };
  return (
    <div className="w-full flex flex-col justify-center items-center bg-[#101e2b]">
      <Navbar />
      <div className="container flex flex-col gap-4 px-4 lg:px-0 mb-[5rem]">
        <div className="mt-[2rem] flex items-center justify-center gap-4 border-b border-[#22BEFF33]">

          <button className={`font-bold text-base cursor-pointer pb-2 uppercase ${active === "vission_mission" ? "border-b-2 border-[#22BEFF] text-[#22BEFF]":"text-gray-300"}`} onClick={()=>setActive('vission_mission')}>Vission & mission</button>
          <button className={`font-bold text-base cursor-pointer pb-2 uppercase ${active === "about_ceo" ? "border-b-2 border-[#22BEFF] text-[#22BEFF]":"text-gray-300"}`} onClick={()=>setActive('about_ceo')}>About Mentor</button>
            

        </div>
        <div className="mt-[2rem]">
          {render()}
        </div>
      </div>
    </div>
  )
}

export default About